import React from 'react';
import T from 'prop-types';

import { MODAL_NEWSLETTER_OPT_IN } from '../../constants/app';

import ConfirmationModal from '../confirmationModal';

const NewsletterOptInModal = ({
  activated,
  confirmNewsletterOptIn,
  error,
  errorMessage,
  isLoading,
  isVisible,
  updateQueryString,
}) => {
  const handleOnOk = () => {
    updateQueryString({
      modal: undefined,
      secret: undefined,
    });
  };

  return (
    <ConfirmationModal
      activated={activated}
      error={error}
      errorMessage={errorMessage}
      isLoading={isLoading}
      isVisible={isVisible}
      loadingMessage="Opting in..."
      name={MODAL_NEWSLETTER_OPT_IN}
      okText="Ok"
      onLoad={confirmNewsletterOptIn}
      onOk={handleOnOk}
      successMessage="Marketing opt-in successful."
      title="Marketing emails Opt-in"
    >
      {alert}
    </ConfirmationModal>
  );
};

NewsletterOptInModal.propTypes = {
  confirmNewsletterOptIn: T.func.isRequired,
  updateQueryString: T.func.isRequired,

  activated: T.bool.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isVisible: T.bool.isRequired,
  isLoading: T.bool.isRequired,
};

export default NewsletterOptInModal;
